import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent';
import {ModalBody} from 'reactstrap';
import {COMPONENT_CHILDREN} from './../Utils2';
import i18n from "./../i18n/i18n";
import classNames from 'classnames';

require("./FormBody.scss");

export default class FormBody extends AbstractReactComponent {

    static contextTypes = {
        isModal: React.PropTypes.bool
    };

    static PropTypes = {
        fieldLabelPrefix: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array]),
        formPath: React.PropTypes.string,
        required: React.PropTypes.bool,
        cards: React.PropTypes.bool,    // pokud je tru, jedná se o dialog, na kterém jsou logické sekce jako karty
        children: COMPONENT_CHILDREN
    };

    static defaultProps = {
        formPath: "",
    };

    static childContextTypes = {
        fieldLabelPrefix: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array]),
        formPath: React.PropTypes.string
    };

    getChildContext() {
        const {fieldLabelPrefix, formPath} = this.props;

        return { fieldLabelPrefix, formPath };
    }

    render() {
        const {cards, children, required, style} = this.props;
        const {isModal} = this.context;

        let requiredInfo;
        if (required) {
            requiredInfo = <div className="required-fields-info">{i18n("global.form.title.contains.required.fields")}</div>;
        }

        const cls = classNames(
            "form-content-container",
            {
                "cards": cards
            }
        );

        if (isModal) {
            return (
                <ModalBody className={cls} style={style}>
                    {children}
                    {requiredInfo}
                </ModalBody>
            )
        } else {
            return (
                <div className={cls} style={style}>
                    {children}
                    {requiredInfo}
                </div>
            )
        }
    }
}
